import { c as _c } from "react/compiler-runtime";
import CheckIcon from "./CheckIcon";
import type { Plan, PlanFeature } from "./data";

/** "**강조**" 마크업을 SemiBold span 으로 변환 (Figma: Pretendard SemiBold) */
const renderEmphasis = (label: string) => {
  const segments = label.split(/(\*\*[^*]+\*\*)/g).filter(Boolean);
  return segments.map((seg, idx) => {
    if (seg.startsWith("**") && seg.endsWith("**")) {
      return <span key={idx} className="font-semibold text-[#16143e]">
          {seg.slice(2, -2)}
        </span>;
    }
    return <span key={idx}>{seg}</span>;
  });
};
const FeatureItem = t0 => {
  const $ = _c(12);
  const {
    feature
  } = t0;
  let t1;
  if ($[0] !== feature.isMuted) {
    t1 = <CheckIcon isMuted={feature.isMuted} />;
    $[0] = feature.isMuted;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== feature.label) {
    t2 = renderEmphasis(feature.label);
    $[2] = feature.label;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== feature.note) {
    t3 = feature.note && <span className="text-[12px] tracking-[-0.12px] text-[#6a6a6a]">{` ${feature.note}`}</span>;
    $[4] = feature.note;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <span className="break-keep text-[14px] leading-[23px] text-[#16143e]">{t2}{t3}</span>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t1 || $[10] !== t4) {
    t5 = <li className="flex items-start gap-2">{t1}{t4}</li>;
    $[9] = t1;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
};
const PlanCard = t0 => {
  const $ = _c(52);
  const {
    plan
  } = t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== plan.badge || $[1] !== plan.description || $[2] !== plan.features || $[3] !== plan.highlightFeature || $[4] !== plan.isFeatured || $[5] !== plan.name || $[6] !== plan.price || $[7] !== plan.pricePeriod) {
    const coreFeatures = plan.features.filter(_temp);
    const mutedFeatures = plan.features.filter(_temp2);
    const cardTone = plan.isFeatured ? "border-primary-300 bg-gradient-to-b from-[#e6f2ff] to-white" : "border-gray-200 bg-white";
    t7 = `relative flex flex-col justify-between rounded-[12px] border px-6 py-8 shadow-[0_4px_24px_rgba(16,20,62,0.06)] ${cardTone}`;
    t4 = "flex flex-col gap-6";
    let t8;
    if ($[15] !== plan.name) {
      t8 = <p className="font-[family-name:var(--font-ibm-plex-sans-kr)] text-[15px] font-semibold tracking-[0.3px] text-[#16143e]">{plan.name}</p>;
      $[15] = plan.name;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== plan.badge) {
      t9 = plan.badge && <span className="shrink-0 break-keep rounded-full bg-[rgba(122,51,255,0.07)] px-[10px] py-[5px] text-[12px] font-medium leading-none text-[#7a33ff]">{plan.badge}</span>;
      $[17] = plan.badge;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== t8 || $[20] !== t9) {
      t10 = <div className="flex items-center justify-between gap-2">{t8}{t9}</div>;
      $[19] = t8;
      $[20] = t9;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    let t11;
    if ($[22] !== plan.price) {
      t11 = <p className="font-[family-name:var(--font-nanum-square-neo)] text-[22px] font-bold leading-[38px] tracking-[-0.76px] text-[#16143e] lg:text-[34px]">{plan.price}</p>;
      $[22] = plan.price;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    let t12;
    if ($[24] !== plan.pricePeriod) {
      t12 = <p className="pb-[2px] text-[15px] tracking-[-0.76px] text-[#727272]">{plan.pricePeriod}</p>;
      $[24] = plan.pricePeriod;
      $[25] = t12;
    } else {
      t12 = $[25];
    }
    let t13;
    if ($[26] !== t11 || $[27] !== t12) {
      t13 = <div className="flex items-end gap-[9px]">{t11}{t12}</div>;
      $[26] = t11;
      $[27] = t12;
      $[28] = t13;
    } else {
      t13 = $[28];
    }
    let t14;
    if ($[29] !== t10 || $[30] !== t13) {
      t14 = <div className="flex flex-col gap-1">{t10}{t13}</div>;
      $[29] = t10;
      $[30] = t13;
      $[31] = t14;
    } else {
      t14 = $[31];
    }
    let t15;
    if ($[32] !== plan.description) {
      t15 = <p className="min-h-[45px] break-keep text-[14px] leading-[22px] text-[#121212]">{plan.description}</p>;
      $[32] = plan.description;
      $[33] = t15;
    } else {
      t15 = $[33];
    }
    if ($[34] !== t14 || $[35] !== t15) {
      t5 = <div className="flex flex-col gap-4">{t14}{t15}</div>;
      $[34] = t14;
      $[35] = t15;
      $[36] = t5;
    } else {
      t5 = $[36];
    }
    if ($[37] !== plan.highlightFeature) {
      t6 = <div className="flex w-full items-center justify-center rounded-[12px] bg-[#e6f2ff] px-4 py-2"><p className="break-keep text-center text-[14px] font-semibold leading-[23px] text-black">{plan.highlightFeature}</p></div>;
      $[37] = plan.highlightFeature;
      $[38] = t6;
    } else {
      t6 = $[38];
    }
    t1 = "flex flex-col gap-[10px]";
    t2 = coreFeatures.map(_temp3);
    t3 = mutedFeatures.length > 0 && <li className="mt-1 flex flex-col gap-[10px] border-t border-[#f0f0f0] pt-[10px]"><ul className="flex flex-col gap-[10px]">{mutedFeatures.map(_temp4)}</ul></li>;
    $[0] = plan.badge;
    $[1] = plan.description;
    $[2] = plan.features;
    $[3] = plan.highlightFeature;
    $[4] = plan.isFeatured;
    $[5] = plan.name;
    $[6] = plan.price;
    $[7] = plan.pricePeriod;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t1 = $[8];
    t2 = $[9];
    t3 = $[10];
    t4 = $[11];
    t5 = $[12];
    t6 = $[13];
    t7 = $[14];
  }
  let t8;
  if ($[39] !== t1 || $[40] !== t2 || $[41] !== t3) {
    t8 = <ul className={t1}>{t2}{t3}</ul>;
    $[39] = t1;
    $[40] = t2;
    $[41] = t3;
    $[42] = t8;
  } else {
    t8 = $[42];
  }
  let t9;
  if ($[43] !== t4 || $[44] !== t5 || $[45] !== t6 || $[46] !== t8) {
    t9 = <div className={t4}>{t5}{t6}{t8}</div>;
    $[43] = t4;
    $[44] = t5;
    $[45] = t6;
    $[46] = t8;
    $[47] = t9;
  } else {
    t9 = $[47];
  }
  let t10;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <a href="#apply" className="mt-8 flex w-full items-center justify-center rounded-full bg-primary-600 px-[22px] py-3 text-[16px] font-semibold text-white transition-colors hover:bg-primary-700">시작하기</a>;
    $[48] = t10;
  } else {
    t10 = $[48];
  }
  let t11;
  if ($[49] !== t7 || $[50] !== t9) {
    t11 = <div className={t7}>{t9}{t10}</div>;
    $[49] = t7;
    $[50] = t9;
    $[51] = t11;
  } else {
    t11 = $[51];
  }
  return t11;
};
export default PlanCard;
function _temp(f) {
  return !f.isMuted;
}
function _temp2(f_0) {
  return f_0.isMuted;
}
function _temp3(feature, idx) {
  return <FeatureItem key={idx} feature={feature} />;
}
function _temp4(feature_0, idx_0) {
  return <FeatureItem key={idx_0} feature={feature_0} />;
}